import React, { useEffect } from "react";
import { FaCheckCircle, FaExclamationTriangle, FaInfoCircle, FaTimes } from "react-icons/fa";
import "./Toast.css";

/**
 * Toast - Einfache Benachrichtigungs-Komponente
 * @param {boolean} show - Toast anzeigen
 * @param {string} message - Nachricht
 * @param {string} type - "success" | "error" | "info"
 * @param {function} onClose - Callback zum Schließen
 * @param {number} duration - Auto-close nach ms (default: 3000, 0 = kein Auto-close)
 */
const Toast = ({ show, message, type = "success", onClose, duration = 3000 }) => {
  useEffect(() => {
    if (show && duration > 0) {
      const timer = setTimeout(() => {
        onClose?.();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, duration, onClose]);

  if (!show) return null;

  const icons = {
    success: <FaCheckCircle />,
    error: <FaExclamationTriangle />,
    info: <FaInfoCircle />,
  };

  return (
    <div className={`toast toast-${type}`}>
      <span className="toast-icon">{icons[type] || icons.info}</span>
      <span className="toast-message">{message}</span>
      <button className="toast-close" onClick={onClose}>
        <FaTimes />
      </button>
    </div>
  );
};

export default Toast;
